var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d, _e, _f;
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from '../constants/actionTypes';
import deepClone from '../utils/deepClone';
var packages = handleActions((_a = {},
    _a[actions.getPackages.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.items) || [];
    },
    _a[actions.getPackagesByIdentifier.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.items) || [];
    },
    _a[actions.getPackagesByIdentifierAdmin.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.items) || [];
    },
    _a[actions.getPublicPackages.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.items) || [];
    },
    _a[actions.updatePackage.type.SUCCESS] = function (state, _a) {
        var _b, _c, _d, _e;
        var payload = _a.payload;
        if (!state) {
            return state;
        }
        var newState = deepClone(state);
        var packageIndex = newState.findIndex(function (pack) { return (pack === null || pack === void 0 ? void 0 : pack.id) === payload.id; });
        if (packageIndex !== -1) {
            newState[packageIndex] = __assign(__assign({}, payload), { retailerName: ((_b = payload.retailer) === null || _b === void 0 ? void 0 : _b.name) || payload.retailerName, carrierName: ((_c = payload.carrier) === null || _c === void 0 ? void 0 : _c.name) || payload.carrierName, retailerId: ((_d = payload.retailer) === null || _d === void 0 ? void 0 : _d.id) || payload.retailerId, partnerCode: ((_e = payload.partner) === null || _e === void 0 ? void 0 : _e.code) || payload.partnerCode });
        }
        return newState;
    },
    _a[actions.createPackage.type.SUCCESS] = function (state, _a) {
        var payload = _a.payload;
        if (!state) {
            return state;
        }
        var newState = __spreadArray(__spreadArray([], state, true), [payload], false);
        return newState;
    },
    _a[actions.onPackageUpdate.type.SUCCESS] = function (state, _a) {
        var payload = _a.payload;
        if (!state || !payload)
            return state;
        var updatedState = state.map(function (pack) {
            return (pack === null || pack === void 0 ? void 0 : pack.id) === payload.id ? __assign(__assign({}, pack), { status: payload.status }) : pack;
        });
        return updatedState;
    },
    _a[actions.getPackages.type.FAILED] = function () { return null; },
    _a[actions.getPublicPackages.type.FAILED] = function () { return null; },
    _a[actions.getPackagesByIdentifier.type.FAILED] = function () { return null; },
    _a[actions.getPackagesByIdentifierAdmin.type.FAILED] = function () { return null; },
    _a), null);
var consolidationPackages = handleActions((_b = {},
    _b[actions.getConsolidationPackages.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.items) || [];
    },
    _b[actions.onPackageUpdate.type.SUCCESS] = function (state, _a) {
        var payload = _a.payload;
        if (!state || !payload)
            return state;
        var updatedState = state.map(function (pack) {
            return (pack === null || pack === void 0 ? void 0 : pack.id) === payload.id ? __assign(__assign({}, pack), { status: payload.status }) : pack;
        });
        return updatedState;
    },
    _b[actions.getConsolidationPackages.type.FAILED] = function () { return null; },
    _b[actions.deleteConsolidationPackage.type.SUCCESS] = function (state, _a) {
        var payload = _a.payload;
        var newState = __spreadArray([], (state || []), true);
        return newState.filter(function (item) { return item.id !== (payload === null || payload === void 0 ? void 0 : payload.packageId); });
    },
    _b[actions.updatePackage.type.SUCCESS] = function (state, _a) {
        var _b, _c, _d, _e;
        var payload = _a.payload;
        if (!state) {
            return state;
        }
        var newState = deepClone(state);
        var packageIndex = newState.findIndex(function (pack) { return (pack === null || pack === void 0 ? void 0 : pack.id) === payload.id; });
        if (packageIndex !== -1) {
            newState[packageIndex] = __assign(__assign({}, payload), { retailerName: ((_b = payload.retailer) === null || _b === void 0 ? void 0 : _b.name) || payload.retailerName, carrierName: ((_c = payload.carrier) === null || _c === void 0 ? void 0 : _c.name) || payload.carrierName, retailerId: ((_d = payload.retailer) === null || _d === void 0 ? void 0 : _d.id) || payload.retailerId, partnerCode: ((_e = payload.partner) === null || _e === void 0 ? void 0 : _e.code) || payload.partnerCode });
        }
        return newState;
    },
    _b), null);
var packagesCount = handleActions((_c = {},
    _c[actions.getPackages.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.pagination.total) || 0;
    },
    _c[actions.getPublicPackages.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return (payload === null || payload === void 0 ? void 0 : payload.pagination.total) || 0;
    },
    _c[actions.getPackagesByIdentifierAdmin.type.SUCCESS] = function (_, _a) {
        var _b;
        var payload = _a.payload;
        return ((_b = payload === null || payload === void 0 ? void 0 : payload.items) === null || _b === void 0 ? void 0 : _b.length) || 0;
    },
    _c[actions.getPackages.type.FAILED] = function () { return null; },
    _c[actions.getPublicPackages.type.FAILED] = function () { return null; },
    _c[actions.getPackagesByIdentifier.type.FAILED] = function () { return null; },
    _c[actions.getPackagesByIdentifierAdmin.type.FAILED] = function () { return null; },
    _c), null);
var currentPackage = handleActions((_d = {},
    _d[actions.getPackage.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return payload || null;
    },
    _d[actions.getPackage.type.FAILED] = function () { return null; },
    _d[actions.updatePackage.type.SUCCESS] = function (state, _a) {
        var payload = _a.payload;
        if (!state) {
            return state;
        }
        if (state.id === (payload === null || payload === void 0 ? void 0 : payload.id)) {
            return payload;
        }
        return state;
    },
    _d[actions.updatePackage.type.FAILED] = function (state) { return state; },
    _d[actions.onPackageUpdate.type.SUCCESS] = function (state, _a) {
        var payload = _a.payload;
        if (!state || !payload) {
            return state;
        }
        if (state.id === (payload === null || payload === void 0 ? void 0 : payload.id)) {
            var newState = __assign(__assign({}, state), { status: payload.status });
            return newState;
        }
        return state;
    },
    _d[actions.clearCurrentPackage.type.REQUEST] = function () { return null; },
    _d), null);
var packageTrackingList = handleActions((_e = {},
    _e[actions.clearPackageTrackingList.type.REQUEST] = function () { return []; },
    _e[actions.packageTrackingList.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return payload || [];
    },
    _e[actions.packageTrackingList.type.FAILED] = function () { return []; },
    _e), []);
var packageTrackingListExpanded = handleActions((_f = {},
    _f[actions.clearPackageTrackingList.type.REQUEST] = function () { return []; },
    _f[actions.packageTrackingListExpanded.type.SUCCESS] = function (_, _a) {
        var payload = _a.payload;
        return payload || [];
    },
    _f[actions.packageTrackingListExpanded.type.FAILED] = function () { return []; },
    _f), []);
export default combineReducers({
    packages: packages,
    packagesCount: packagesCount,
    currentPackage: currentPackage,
    consolidationPackages: consolidationPackages,
    packageTrackingList: packageTrackingList,
    packageTrackingListExpanded: packageTrackingListExpanded,
});
//# sourceMappingURL=packages.js.map